import { apiClient as api } from './client';

export interface UniverseInfo {
  universe_id: string;
  name: string;
  paused: boolean;
  leaderboard_enabled: boolean;
  visibility_enabled: boolean;
}

export interface LeaderboardEntry {
  user_id: string;
  name: string;
  planet_name: string;
  stage: number;
  credits: number;
  score?: number;
  factionGoal?: string | null;
  scoreBreakdown?: Record<string, number>;
  recentScoreEvents?: Array<{
    reason: string;
    points: number;
    category: string;
    createdDay?: number | null;
  }>;
}

export interface Classmate {
  user_id: string;
  name: string;
  planet_name: string;
  stage: number;
}

export async function getMyUniverse(): Promise<{ success: boolean; data: UniverseInfo }> {
  const res = await api.get('/universes/me');
  return res.data;
}

export async function getLeaderboard(universeId: string): Promise<{ success: boolean; data: LeaderboardEntry[] }> {
  const res = await api.get(`/universes/${universeId}/leaderboard`);
  return res.data;
}

export async function getClassmates(universeId: string): Promise<{ success: boolean; data: Classmate[] }> {
  const res = await api.get(`/universes/${universeId}/classmates`);
  return res.data;
}
